import Title from './titles/Title';
import { Link } from 'react-router-dom';
import RatingCards from './rating/RatingCards';
import classes from './CardBestsellers.module.css';
import CategoryCards from './category/CategoryCards';
import { isPlanLocked } from '../../../utils/helpers/subscriptions/utils';
import ProgressiveImage from '../../progressiveImage/ProgressiveImage';
import { LanguageContext } from '../../../context/LanguageContext';
import { useCurrentUser } from '../../../hooks/useCurrentUser';

const CardBestsellers = (props) => {
  const { data, categories, img, bestsellers, className, style, height_unset } = props;
  const { mx_auto, imageClasses, padding_unset, dataContainer, requiredPlan } = props;

  const { user } = useCurrentUser();
  const isLocked = isPlanLocked(user?.plan, requiredPlan);

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        const cardContent = (
          <div
            className={style ? style : `${classes.card_item} ${classes.card_container} ${bestsellers ? classes.max_width_300 : ""} ${classes.ellipsis} ${dataContainer} d-flex justify-content-center text-decoration-none w-100 h-100 flex-wrap overflow-hidden text-nowrap`}
            style={{ position: "relative" }}
          >
            <div
              className={height_unset ? height_unset : `${classes.card_item_img_container} ${classes.card_container} d-flex justify-content-center text-decoration-none w-100 align-items-center`}
            >
              <div className={mx_auto ? mx_auto : classes.bestsellers}>
                <ProgressiveImage src={img} alt="" className={imageClasses} />
              </div>
            </div>

            <div className={`${classes.card_item_rating_container} d-flex justify-content-start align-items-center w-100 justify-content-center`}>
              <RatingCards data={data} />
            </div>

            <Title data={data} maxWidth={"200px"}/>

            {categories && (
              <CategoryCards
                data={data}
                categories={categories}
                padding_unset={padding_unset}
                className={classes.padding_0_20}
                maxWidth={"200px"}
              />
            )}

            {isLocked && (
              <div className={classes.lockedOverlay}>
                <img src="/assets/products/locked.svg" alt="" width={35} height={35}/>
              </div>
            )}
          </div>
        );

        if (isLocked) {
          return (
            <Link 
              to="/subscription-plans"
              className={`${classes.card_bestseller} ${className} d-flex justify-content-center text-decoration-none`}
            >
              {cardContent}
            </Link>
          );
        }

        return (
          <Link
            to={`/products/${data?._id}`}
            className={`${classes.card_bestseller} ${className} d-flex justify-content-center text-decoration-none`}
          >
            {cardContent}
          </Link>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default CardBestsellers;